import { __assign } from 'tslib';
import { makeStyles } from '@material-ui/core';

var borderWidth = 1;
var getColor = function (palette, props) {
    var variant = props.variant;
    var color = 'inherit';
    if (['primary', 'info', 'success', 'warning', 'error'].includes(variant)) {
        // @ts-expect-error - todo.
        color = palette[variant].contrastText;
    }
    if (variant === 'secondary') {
        color = palette[variant].main;
        /**
         * Temporary fix for dark theme buttons.
         * Dark theme will be addressed in ch-11596 and the following if block should be removed
         */
        if (palette.type === 'dark') {
            color = 'black';
        }
    }
    if (variant === 'tertiary') {
        color = palette.secondary.contrastText;
    }
    if (variant === 'text') {
        color = palette.info.main;
    }
    return color;
};
var getColorHover = function (palette, props) {
    var color;
    if (props.variant === 'secondary') {
        color = palette.secondary.contrastText;
    }
    return color;
};
var getBackground = function (palette, props) {
    var backgroundColor = 'inherit';
    if (['info', 'success', 'warning', 'error'].includes(props.variant)) {
        // @ts-expect-error - todo.
        backgroundColor = palette[props.variant].main;
    }
    if (props.variant === 'primary') {
        // @ts-expect-error gradient colors are included in the extended palette.
        backgroundColor = "linear-gradient(97.36deg, " + palette.primary.gradientStart + " 17.03%, " + palette.primary.gradientEnd + " 72.96%)";
    }
    if (props.variant === 'secondary') {
        backgroundColor = 'white';
    }
    if (props.variant === 'tertiary') {
        backgroundColor = palette.secondary.main;
    }
    return backgroundColor;
};
var getBackgroundHover = function (palette, props) {
    var backgroundHoverColor = 'inherit';
    if (['primary', 'info', 'success', 'warning', 'error'].includes(props.variant)) {
        // @ts-expect-error - todo.
        backgroundHoverColor = palette[props.variant].dark;
    }
    if (props.variant === 'secondary') {
        backgroundHoverColor = palette.secondary.main;
    }
    if (props.variant === 'tertiary') {
        backgroundHoverColor = palette.secondary.light;
    }
    if (props.variant === 'text' || props.variant === 'ghost') {
        backgroundHoverColor = palette.action.hover;
    }
    return backgroundHoverColor;
};
var buttonTypography = {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
};
var useButtonStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: function (props) { return ({
            minWidth: 'unset',
            color: getColor(palette, props),
            background: getBackground(palette, props),
            backgroundColor: props.variant === 'primary' ? palette.primary.dark : getBackground(palette, props),
            borderRadius: spacing(6),
            transition: 'all 200ms ease-in-out',
            '&:hover': {
                color: getColorHover(palette, props),
                background: getBackgroundHover(palette, props),
            },
        }); },
        disabled: {
            '&$root': {
                background: palette.action.disabled,
            },
        },
        contained: {
            padding: spacing(1, 2),
        },
        outlined: {
            padding: "calc(" + spacing(1) + "px - " + borderWidth + "px) calc(" + spacing(2) + "px - " + borderWidth + "px)",
            '&$sizeSmall': {
                padding: "calc(" + spacing(0.5) + "px - " + borderWidth + "px) calc(" + spacing(2) + "px - " + borderWidth + "px)",
            },
            '&$sizeLarge': {
                padding: "calc(" + spacing(1.5) + "px - " + borderWidth + "px) calc(" + spacing(2) + "px - " + borderWidth + "px)",
            },
        },
        text: {
            padding: spacing(1, 2),
        },
        label: __assign(__assign({}, buttonTypography), { textTransform: function (props) { return props.textTransform; } }),
        sizeSmall: {
            padding: spacing(0.5, 2),
        },
        sizeLarge: {
            padding: spacing(1.5, 2),
        },
    });
});

export { buttonTypography, useButtonStyles };
//# sourceMappingURL=ButtonStyles.js.map
